// Mirrors GameScene.swift::sortZ* constants. Phaser uses `depth` instead of
// SpriteKit's `zPosition`; the numeric meaning is the same.
export const Z = {
  background: 0,
  sky: 2,
  clouds: 3,
  grassAndHills: 4,
  colorSquare: 5,
  colorPickerFrame: 6,
  colorPicker: 7,
  colorPickerCountCircle: 9,
  colorPickerCountFill: 11,
  colorPickerCount: 12,
  dogHouse: 7,
  dogBowl: 8,
  menu: 8,
  eyes: 9,
  dogHouseFull: 9,
  bottomBar4: 10,
  board: 10,
  bigPuppy: 11,
  grassSprites: 12,
  colorSprites: 14,
  bonusSprites: 16,
  hintSprites: 16,
  bestSquare: 17,
  puppySprites: 17,
  sparkleSprites: 18,
  cantPlayX: 18,
  undoCantUndo: 19,
  headerLevelLabels: 20,
  megaPuppyExplosion: 21,
  megaPuppySprite: 22,
  circleOfStars: 25,
  smileyExplosion: 27,
  plus100: 30,
  megaPuppyGfx: 36,
  bottomBar3_5: 37,
  scoreAndLevel: 37,
  timerCount: 37,
  bigTempPuppy: 38,
  howMuch: 38,
  newLevel: 42,
  settingsBlurryBkgnd: 48,
  settings: 50,
  gameOverBlurryBkgnd: 58,
  gameOver: 60,
  dogHouseBonus: 95,
  goToDogHouse: 100,
} as const;
